<div class="loadbalancer-message" [hidden]="!licenseMessage">
    <p routerLink="./local-configuration/licence">
        {{ licenseMessage }}
    </p>
</div>
